import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, Minus, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Section } from "./ui";

const PRICE = 19.9;
const INCLUDED = ["Postes Windows, macOS et Linux illimités", "Prise en main, voix, chat, fichiers", "Supervision RMM, mises à jour, logiciels", "Rapports mensuels et alertes", "Sessions ponctuelles par code", "Double authentification et journal d'audit"];
const eur = (v) => v.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });

const Calculator = () => {
  const [n, setN] = useState(2);
  return (
    <div className="rounded-2xl border border-slate-800 p-8" data-testid="pricing-calculator">
      <h3 className="font-bold text-lg mb-2">Combien de techniciens ?</h3>
      <p className="text-sm text-slate-400 mb-6">1 licence = 1 technicien = 1 prise en main à la fois. Le nombre de postes est illimité.</p>
      <div className="flex items-center gap-4 mb-6">
        <button onClick={() => setN(Math.max(1, n - 1))} className="h-10 w-10 grid place-items-center rounded-full border border-slate-700 hover:bg-slate-800" data-testid="pricing-minus" aria-label="Moins"><Minus className="h-4 w-4" /></button>
        <span className="text-3xl font-extrabold w-12 text-center" data-testid="pricing-techs">{n}</span>
        <button onClick={() => setN(Math.min(50, n + 1))} className="h-10 w-10 grid place-items-center rounded-full border border-slate-700 hover:bg-slate-800" data-testid="pricing-plus" aria-label="Plus"><Plus className="h-4 w-4" /></button>
        <span className="text-slate-400 text-sm">technicien{n > 1 ? "s" : ""}</span>
      </div>
      <div className="rounded-lg bg-slate-800/40 border border-slate-800 p-4 text-slate-300">
        {n} × 19,90 € = <strong className="text-white text-lg" data-testid="pricing-total">{eur(n * PRICE)}</strong> / mois HT · jusqu'à {n} prise{n > 1 ? "s" : ""} en main simultanée{n > 1 ? "s" : ""}
      </div>
      <p className="text-xs text-slate-500 mt-4">Ajoutez ou retirez des licences à tout moment depuis votre espace, la facturation s'ajuste automatiquement.</p>
    </div>
  );
};

export const Pricing = () => (
  <Section id="tarifs" className="bg-[#0B1120]" over="TARIFS" title="Un prix simple, par technicien" lead="Pas de facturation au poste, pas de module en option : tout ScreenView est inclus.">
    <div className="grid lg:grid-cols-[380px_1fr] gap-8 items-start">
      <div className="rounded-2xl border border-sky-500/40 bg-sky-500/[0.06] p-8" data-testid="pricing-card">
        <p className="font-semibold text-sky-400">Licence technicien</p>
        <div className="flex items-end gap-1 mt-4"><span className="text-5xl font-extrabold tracking-tight">19,90 €</span><span className="text-slate-400 mb-1">/ mois</span></div>
        <p className="text-sm text-slate-400 mt-1">par technicien · sans engagement</p>
        <ul className="mt-6 space-y-3 text-sm">
          {INCLUDED.map((t) => <li key={t} className="flex gap-2.5"><Check className="h-4 w-4 text-sky-400 flex-shrink-0 mt-0.5" /><span className="text-slate-300">{t}</span></li>)}
        </ul>
        <Button asChild size="lg" className="rounded-full w-full mt-8"><Link to="/register" data-testid="pricing-register-btn">Commencer l'essai gratuit</Link></Button>
      </div>
      <Calculator />
    </div>
  </Section>
);
